import React from 'react';
import styled from 'styled-components';
import { Button, Icon, Text, Logo } from '../index';

type Props = {
  buttonTitle?: string,
  buttonOnClick?: Function,
  buttonIconName?: string,
  headerLogo?: Object,
  iconNameArray: Array,
  iconOnClick?: Function,
};

const StyledListHeader = styled.div`
  padding: 5px 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;

  #icon-button {
    cursor: pointer;
  }
`;

const ListHeader = (props: Props) => {
  const {
    buttonTitle,
    buttonOnClick,
    buttonIconName,
    iconNameArray,
    headerLogo,
    iconOnClick,
  } = props;

  return (
    <StyledListHeader>
      {buttonTitle && (
        <Button
          className="d-flex align-items-center justify-content-center"
          type="primary"
          onClick={buttonOnClick}
          iconName={buttonIconName}
          text={buttonTitle}
        />
      )}
      <div className="d-flex align-items-center justify-content-between h-100">
        {headerLogo ? (
          <></>
          // <Logo width="50" height="22" logoName="gray-logo" />
        ) : null}
        {iconNameArray &&
          iconNameArray.length &&
          iconNameArray.map((iconNameItem) => {
            const { title, iconName, id } = iconNameItem;
            return (
              <Text
                id="icon-button"
                color="primary"
                key={id}
                size={'sm'}
                className="d-flex align-items-center justify-content-center mx-2"
                onClick={() => {
                  iconOnClick(id);
                }}
              >
                {title && title}
                {iconName && <Icon name={iconName} color="primary" />}
              </Text>
            );
          })}
      </div>
    </StyledListHeader>
  );
};

export default ListHeader;
